export default __webpack_public_path__ + "static/media/trang-chu-1.5a191c1b.png";